import React from 'react'
import { AccessibilityTestMenuProps } from '../types'
import ToolsMenuItem from '@app/components/common/TestToolsMenu/components/ToolsMenuItem'
import { faEyeSlash, faFrame } from '@fortawesome/pro-solid-svg-icons'
import TextResize from '@app/components/common/TextResize'

const AccessibilityMenuItem: React.FC<AccessibilityTestMenuProps> = ({
  isReviewMode,
  answerMaskingControl,
  screenMaskingControl,
  fontSizeControl,
}) => {
  return (
    <>
      {fontSizeControl && <TextResize {...fontSizeControl} isMobile />}
      {!isReviewMode ? (
        <>
          {answerMaskingControl?.featureFlagEnabled && (
            <ToolsMenuItem
              icon={faEyeSlash}
              label='Answer Masking'
              checked={answerMaskingControl.checked}
              onChange={answerMaskingControl.toggle}
            />
          )}
          {screenMaskingControl?.featureFlagEnabled && (
            <ToolsMenuItem
              icon={faFrame}
              label='Screen Masking'
              checked={screenMaskingControl.checked}
              onChange={screenMaskingControl.toggle}
            />
          )}
        </>
      ) : null}
    </>
  )
}

export default AccessibilityMenuItem
